import React from 'react';
import PropTypes from 'prop-types';
// Components
import MenuItem from './menu-item';
import { OrderedList } from '../../styled/typography.js';

const MenuList = ({ items, currentPath }) => (
  <OrderedList>
    {items.map((item, i) => (
      <MenuItem active={item.path === currentPath} item={item} key={i} />
    ))}
  </OrderedList>
);

MenuList.propTypes = {
  items: PropTypes.array,
  currentPath: PropTypes.string,
};

export default MenuList;
